import React from "react";
import { motion } from "framer-motion";
import { useReveal } from "../../hooks/useReveal";
import { EASE, DURATIONS, prefersReducedMotion } from "../../lib/motion";

/**
 * Reveal — once-in-viewport fade + translateY.
 * Phase 7: variant-aware; `image` variant uses larger amplitude + longer duration.
 * Respects prefers-reduced-motion.
 */
export const Reveal = ({
  as: As = motion.div,
  delay = 0,
  variant = "text", // "text" | "image"
  className = "",
  children,
  ...rest
}) => {
  const [ref, visible] = useReveal();
  const reduce = prefersReducedMotion();

  const offset = variant === "image" ? 32 : 20;
  const duration = variant === "image" ? DURATIONS.revealImage : DURATIONS.reveal;

  if (reduce) {
    return (
      <div ref={ref} className={className} {...rest}>
        {children}
      </div>
    );
  }

  return (
    <As
      ref={ref}
      initial={{ opacity: 0, y: offset }}
      animate={visible ? { opacity: 1, y: 0 } : { opacity: 0, y: offset }}
      transition={{ duration, ease: EASE, delay: delay / 1000 }}
      className={className}
      {...rest}
    >
      {children}
    </As>
  );
};

export default Reveal;
